import {useEffect, useRef} from 'react'

import {isInsidePortal} from '../../helpers/portal-elements'
import {useDeselectAll} from './use-deselect-all'

export const useSelectionBlur = () => {
  const containerRef = useRef<HTMLDivElement>(null)

  const deselectAll = useDeselectAll()

  useEffect(() => {
    function onMouseDown(e: MouseEvent) {
      const target = e.target as HTMLElement | null
      // Skip deselection for clicks on parent issue title links
      // TODO: https://github.com/github/memex/issues/20943
      if (target?.closest('[data-component="parent-issue-title"]')) return
      if (!containerRef.current?.contains(target) && !isInsidePortal(target)) {
        deselectAll()
      }
    }

    document.addEventListener('mousedown', onMouseDown)
    return () => {
      document.removeEventListener('mousedown', onMouseDown)
    }
  }, [deselectAll])

  return {containerRef}
}
